module.exports = __webpack_public_path__ + "media/images/backgrounds/glin-symbol-white-e0611179f8a5954d16d7a13f03df3bd4.png";